import React from "react";
import { Helmet } from "react-helmet";
import { IconButton } from "@material-tailwind/react";
import { Container } from "postcss";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "react-headless-accordion";

const Faq = () => {
  const data = [
    {
      title: "What type of properties do Al Ghaith Properties own?",
      content: "Commercial, residential, and warehouse properties.",
    },
    {
      title: "What does Al Ghaith Properties residential property consist of?",
      content:
        "Villas: We offer a diverse selection of villas featuring 3, 4, and 5 bedrooms.",
      content2: "Apartments: We offer a variety of apartment types, from one- to two-bedroom units. These are suitable for individuals, couples, and small families, providing convenient living space with access to communal amenities.",
      content3: ""
    },
    {
      title: "What does Al Ghaith Properties commercial property consist of?",
      content:
        "Our commercial property consists of showrooms, offices, retail units, and warehouses, designed to support a variety of business needs.",
    },
    {
      title:
        " How many square meters (or square feet) are the villas that Al Ghaith Properties have?",
      content:
        "Our villas range in size from approximately 2,000 to 6,000 square meters, offering a variety of layouts and features to suit different needs and preferences. Each property includes spacious living areas, multiple bedrooms, landscaped gardens, and premium amenities. Some villas also come with private pools, guesthouses, or additional service quarters, depending on the unit.",
    },
    {
      title: " What kind of amenities are Al Ghaith Properties providing?",
      content:
        "Most of the residential properties are equipped with surveillance cameras, garden areas, private swimming pools, 24/7 security services, and a host of other premium amenities.",
    },
    {
      title: " Where are the villas & apartments located?",
      content:
        "We own several villas available for rent in various locations, such as:",
      content2: "Al Garhoud",
      content3:"Rashidiya",
      content4:"Jumeirah 3",
      content5:"Al Hudaiba",
      content6:"Al Jafiliya",
    },
    {
      title:
        " Where are the showrooms, retail units, offices, and warehouses located?",
      content: "Ras Al Khor",
      content2: "Al Quoz",
      content3:"Port Saeed",
      content4:"Al Jafiliya",
    },
    {
      title:
        " Do Al Ghaith Properties have varying rental prices for the different villas you offer?",
      content:
        "The price of our villas depends on the location, size, and specific features of each property. For example, villas in prime areas like Jumeirah are priced higher compared to those in Rashidiya and Al Jafiliya.",
    },
    {
      title: " What is the typical price range for the villas Al Ghaith Properties offer?",
      content:
        "It depends on location.The price range for Jumeirah Villas (residential or commercial) is:",
        content2:"Residential: 500k to 600k",
        content3:"Commercial: 500k to 800k",
        content4:"The price range for other villas is from 175k to 300k."
    },
    {
      title: " What is the starting price for apartments?",
      content:
        "The starting price for apartments is 60k, depending on the type and location.",
    },
  ];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FAQ | Al Ghaith Properties</title>
        <meta name="description" content="Find answers to frequently asked questions about Al Ghaith Properties, our services, property types, and rental information in Dubai." />
        <link rel="canonical" href="https://www.al-ghaith.ae" />
      </Helmet>
      <section className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 py-16 px-2 md:px-0">
        <div className="max-w-3xl mx-auto">
          <h1 className="mb-8 md:text-5xl text-3xl font-extrabold text-blue-900 text-center drop-shadow-lg">
            Frequently Asked Questions
            <br />
            <span className="text-blue-700 text-xl font-semibold tracking-wide">Al Ghaith Properties</span>
          </h1>
          <div className="rounded-2xl shadow-xl bg-white/80 p-6 md:p-10">
            <Accordion transition={{duration: "500ms", timingFunction: "cubic-bezier(0, 0, 0.2, 1)"}}>
              {data.map((item, index) => (
                <AccordionItem key={index}>
                  {({ open }) => (
                    <div className="mb-4">
                      <AccordionHeader className={`flex items-center justify-between px-6 py-4 rounded-lg cursor-pointer transition-colors duration-300 ${open ? 'bg-blue-900 text-white' : 'bg-blue-100 text-blue-900'} shadow-sm hover:bg-blue-200`}>
                        <span className="font-semibold text-lg">{item.title}</span>
                        <svg className={`w-6 h-6 transform transition-transform duration-300 ${open ? 'rotate-90' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" /></svg>
                      </AccordionHeader>
                      {open && (
                        <AccordionBody className="bg-blue-50 rounded-b-lg px-6 py-4 border-t border-blue-200">
                          <ul className="space-y-2 text-blue-900 text-base">
                            {item.content && <li>{item.content}</li>}
                            {item.content2 && <li>{item.content2}</li>}
                            {item.content3 && <li>{item.content3}</li>}
                            {item.content4 && <li>{item.content4}</li>}
                            {item.content5 && <li>{item.content5}</li>}
                            {item.content6 && <li>{item.content6}</li>}
                          </ul>
                        </AccordionBody>
                      )}
                    </div>
                  )}
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
